var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 13L7.4453 13.8321L8 14.2018L8.5547 13.8321L8 13ZM8 13C8.5547 13.8321 8.55495 13.8319 8.55522 13.8317L8.55582 13.8313L8.55731 13.8303L8.56139 13.8276L8.57385 13.8191L8.61532 13.7906C8.65008 13.7665 8.69879 13.7321 8.75947 13.6881C8.88074 13.6 9.05038 13.4727 9.25233 13.31C9.65469 12.9859 10.1932 12.515 10.7348 11.9283C11.786 10.7895 13 9.05122 13 7C13 5.67392 12.4732 4.40215 11.5355 3.46447C10.5979 2.52678 9.32608 2 8 2C6.67392 2 5.40215 2.52678 4.46447 3.46447C3.52678 4.40215 3 5.67392 3 7C3 9.05122 4.21404 10.7895 5.2652 11.9283C5.8068 12.515 6.34531 12.9859 6.74767 13.31C6.94962 13.4727 7.11926 13.6 7.24053 13.6881C7.30121 13.7321 7.34992 13.7665 7.38468 13.7906L7.42615 13.8191L7.43861 13.8276L7.44269 13.8303L7.44418 13.8313L7.44478 13.8317C7.44505 13.8319 7.4453 13.8321 8 13Z",
    stroke: "#007f90",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9C9.10457 9 10 8.10457 10 7C10 5.89543 9.10457 5 8 5C6.89543 5 6 5.89543 6 7C6 8.10457 6.89543 9 8 9Z",
    fill: "#007f90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/location-pin.d43c55adffee0751842454c58b5d206a.svg";
export { ForwardRef as ReactComponent };